// extracted by mini-css-extract-plugin
export default {"w-full":"Messages_w-full__7aH9w","messages":"Messages_messages__l7WzH","wrapper":"Messages_wrapper__pyWop","button":"Messages_button__Hp44W","list":"Messages_list__Vw24k"};